module.exports = __webpack_public_path__ + "static/media/google-play.8c5faaea.png";